export enum NodeStatusEnum {
    PUBLIC = 'public',
    ACTIVE = 'active',
    DELETED = 'deleted',
    DRAFT = 'draft'
}